import ChevronLeft from "@mui/icons-material/ChevronLeft";
import Button, { type ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { CustomLink } from "./CustomLink";

export function BackButton({ children, href, ...props }: ButtonProps) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:BackButton",
  });
  return (
    <Button
      variant="outlined"
      href={href}
      LinkComponent={href ? CustomLink : undefined}
      startIcon={<ChevronLeft />}
      {...props}
    >
      {children ?? t("buttonText")}
    </Button>
  );
}
